// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  userServiceUrl: 'https://ab-daniel.internal.sparbankensyd.se/service', // Ch
  defectServiceUrl: 'https://ab-daniel.internal.sparbankensyd.se/api', // Make sure this matches the backend
  domain: 'ab-stage.internal.sparbankensyd.se'
}
